<template>
  <div class="row">
    <div class="col-sm-12 chart-row">
      <overview-chart :value="filter === 'future' ? futureOverview : todaysOverview" />
    </div>
    <div class="col-sm-6">
      <overview-summary title="Total Retirement Benefit"
        :value="filter === 'future' ? futureTotalRetirementBenefit : todaysTotalRetirementBenefit" />
    </div>
    <div class="col-sm-6">
      <overview-summary title="Present Value*"
        :value="filter === 'future' ? futurePresentValue : todaysPresentValue" />
    </div>
    <div class="col-12">
      <more-info :moreInfo="moreInfo.overview" @click="moreInfoOpen" />
    </div>
  </div>
</template>

<script>
import OverviewMixin from '@/js/mixins/calculator/results/overview/overview-mixin';

export default {
  mixins: [OverviewMixin],
};
</script>

<style lang="scss" scoped>
  .chart-row {
    margin-bottom: 15px;
  }
</style>
